import { all, takeEvery, call } from 'redux-saga/effects';
import { isApiError, requestPuppy } from '@wix/da-http-client';
import { PapiDaSharedGallectionFolders } from '@wix/da-papi-types';
import { fetchGallections } from '../actions/gallections';

function* fetchGallectionsSaga(action: ReturnType<typeof fetchGallections>) {
  const { type, username, folderId, offset, limit, onSuccess, onError } =
    action.payload;

  const response: PapiDaSharedGallectionFolders | false = yield call(
    requestPuppy,
    {
      method: 'get',
      url: 'gallection/folders',
      params: { type, username, folderId, offset, limit },
    }
  );

  if (!response || isApiError(response)) {
    if (onError) {
      yield call(onError, response);
    }
    return;
  }

  if (onSuccess) {
    yield call(onSuccess, response);
  }
}

export default function* gallectionsSaga() {
  yield all([takeEvery(fetchGallections, fetchGallectionsSaga)]);
}
